export const VestIsolateType = {
  Each: 'Each',
  Focused: 'Focused',
  Group: 'Group',
  OmitWhen: 'OmitWhen',
  SkipWhen: 'SkipWhen',
  Suite: 'Suite',
  Test: 'Test',
};
